<!------------------------------

      Page Actions

------------------------------->
<ng-container *sbPageAction>
  <sb-button ngbTooltip="{{ 'lang.globals.refresh' | translate }}" placement="top" container="body"
             classes="btn-default actionButtonMinWidth" (click)="requestDebounced()" [disabled]="loading"
             [loading]="loading">
    <sb-icon icon="refresh"></sb-icon>
  </sb-button>
  <a [class.disabled]="loading" *ngPermissions="permissionService.Permission.content_editor"
     [sbRouterLink]="util.RoutingID.contentEditorCreate"
     [queryParams]="{returnTo: this.util.getPageLink()}">
    <sb-button classes="btn-success m-0">
      <sb-icon [icon]="'plus'"></sb-icon>&nbsp;<span class="d-none d-sm-inline-block"> {{
        'lang.globals.create' |
          translate
      }}</span>
    </sb-button>
  </a>
</ng-container>
<!------------------------------

    Table wrapper

------------------------------->

<sb-table-wrapper headline="{{'nav.contentEditor' | translate}}" [itemsData]="templateStoreDTOs"
                  (filterChange)="requestDebounced()" [options]="options" (optionsChange)="requestDebounced($event)"
                  [loading]="loading" [itemName]="'contents'" [showExactMatch]="true">

  <!------------------------------

      Header More

  ------------------------------->

  <!-- no Header more -->

  <!------------------------------

      Table Header

------------------------------->

  <ng-template #thead>


    <tr>
      <th>
        #
      </th>
      <th>
        {{ 'lang.globals.name' | translate }}
      </th>
      <th>
        {{ 'lang.globals.description' | translate }}
      </th>
      <th>
        {{ 'lang.globals.modifiedAt' | translate }}
      </th>
      <th>
        {{ 'lang.globals.created' | translate }}
      </th>
      <th class="text-end">
      </th>
    </tr>
  </ng-template>

  <!------------------------------

      Table Body

------------------------------->
  <ng-template #tbody let-item>

    <tr>
      <td>
        {{ item.id }}
      </td>
      <td>
        {{ item?.name }}
      </td>
      <td>
        {{ item?.description }}
      </td>
      <td>
        <sb-comp-display-modified [data]="item" [hideTooltip]="true"></sb-comp-display-modified>
      </td>
      <td>
        <sb-comp-display-created [data]="item"></sb-comp-display-created>
      </td>
      <td class="text-end sticky-col first-col tableBg">
        <sb-table-buttons>
          <a ngbTooltip="{{ 'nav.contentEditor.createContent' | translate }}"
             *ngIf="permissionService.hasPermission(permissionService.Permission.content_editor) && permissionService.hasPermission(permissionService.Permission.company_list)"
             [sbRouterLink]="util.RoutingID.contentEditorCreateContent"
             [pathParams]="[{id: 'contentEditorID', value: item?.id}]"
             [queryParams]="{returnTo: this.util.getPageLink()}" container="body"
             class="btn btn-success">
            <sb-icon icon="plus"></sb-icon>
          </a>
          <a ngbTooltip="{{ 'lang.globals.edit' | translate }}"
             *ngPermissions="permissionService.Permission.template_store_edit"
             [sbRouterLink]="util.RoutingID.contentEditorEdit"
             [pathParams]="[{id: 'contentEditorID', value: item?.id}]"
             [queryParams]="{returnTo: this.util.getPageLink()}" container="body"
             class="btn btn-secondary">
            <sb-icon icon="edit"></sb-icon>
          </a>
        </sb-table-buttons>
      </td>
    </tr>
  </ng-template>
  <!------------------------------

  Card Element

------------------------------->

  <!-- No card depiction -->
</sb-table-wrapper>
